module.exports = __webpack_public_path__ + "static/img/name3.cca3494.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/th/name3.png
// module id = QR8R
// module chunks = 1